import { useMemo, type FC, type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: {
      paddingTop: '40%',
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: 32
    },
    content: { flexDirection: 'column', alignItems: 'center', gap: 16 },
    text: { textAlign: 'center', color: theme.colors.onSurfaceVariant }
  });

type Props = {
  image?: ReactNode;
  text: string;
};

/**
 * Displays a horizontally and vertically centered image and text.
 * Can be used for both error and empty states.
 */
export const NonIdealState: FC<Props> = ({ image, text }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {image}
        <Text variant="titleMedium" style={styles.text}>
          {text}
        </Text>
      </View>
    </View>
  );
};
